import { validateDate } from '../../../../../Passenger/utils';
import { SubsidyInfoFragment, TravellerFieldEnum } from '@websky/graphql';

export const findSubsidyForPassenger = (passengerValues: any, subsidies: SubsidyInfoFragment[]): string => {
	if (!subsidies || !subsidies.length) {
		return null;
	}

	return subsidies.find(subsidy => {
		return subsidy.validation.every(validation => {
			const value = passengerValues[validation.name];

			return validation.validationRules.some(rules => {
				if (
					!rules.with?.length ||
					rules.with.every(cond => checkValue(passengerValues, cond.name, cond.value))
				) {
					if (validation.type === TravellerFieldEnum.BirthDate) {
						return typeof validateDate(value, rules) !== 'string';
					}

					if (rules.options?.length) {
						return rules.options.some(option => checkValue(passengerValues, validation.name, option.value));
					}
				}

				return false;
			});
		});
	})?.id;
};

export const checkValue = (allValues: any, name: string, value: string) => {
	return allValues[name] === value;
};
